//import { useParams } from 'react-router';
//import { useWorkflow } from '@hooks/useWorkflow';
import { PrimaryHeader } from '@components/global';
import { Box, CTA } from '@components/global';
import styled from '@emotion/styled';

const mockReq = {
  phoneNumber: '(703) 123-4567',
  callPurpose: 'You are requesting a change of address.',
  cardType: 'Venture',
  last4: '1234',
};

const NextStep = styled('div')`
  position: absolute;
  bottom: 150px;
  font-family: Optimist;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5rem;
  padding: 8px 24px;
  text-align: left;
`;

const TextHeading = styled('div')`
  display: block;
  font-family: Optimist;
  font-size: 0.875rem;
  font-weight: 600;
  letter-spacing: 0.5px;
  line-height: 1.25rem;
  padding: 8px 0;
  text-transform: uppercase;
`;

const TextContent = styled('div')`
  font-family: Optimist;
  font-size: 1.25rem;
  font-weight: 300;
  line-height: 1.875rem;
  padding: 8px 0;
  text-align: left;
`;

export const CallCenter = () => {
  // const { processId } = useParams();
  const { phoneNumber, callPurpose, cardType, last4 } = mockReq;

  //const { domain, templateJson } = useWorkflow()

  return (
    <div data-testid="CallCenter">
      <PrimaryHeader
        style={{
          backgroundColor: '#FFFFFF',
          color: '#011728',
          fontWeight: '600',
          fontSize: '1.25rem',
        }}
      >
        Verify your active call
      </PrimaryHeader>
      <Box>
        <TextHeading>Call Details</TextHeading>
        <TextContent>
          You’re calling from this number,{' '}
          <span style={{ fontWeight: 'bold' }}>{phoneNumber}</span> at{' '}
          <span style={{ fontWeight: 'bold' }}>
            {' '}
            {new Date().toLocaleTimeString()}
          </span>
          .
        </TextContent>
      </Box>
      <Box>
        <TextHeading>Purpose of Your Call</TextHeading>
        <TextContent>{`${callPurpose}`}</TextContent>
      </Box>
      <NextStep>
        Next, you'll need to verify your
        <span style={{ fontWeight: 'bold' }}>
          {' '}
          ${cardType} card ending in ${last4}{' '}
        </span>
        to complete identity verification.
      </NextStep>
      <CTA
        data-testid="CTA--Button"
        primaryText="This looks good"
        primaryCallback={() => {
          console.log('good clicked');
        }}
        secondaryText="Stop this call"
        secondaryCallback={() => {
          console.log('stop clicked');
        }}
      />
    </div>
  );
};
